module.exports = __webpack_public_path__ + "img/bg-tt.e1328586.jpg";